import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
export var SpinnerLoader = function (props) {
    var classNames = namespacedClassnames('spinner-loader');
    var style = !!props.color ? {
        background: props.color
    } : {};
    return (React.createElement("div", { className: classNames },
        React.createElement("div", { className: 'bounce1', style: style }),
        React.createElement("div", { className: 'bounce2', style: style }),
        React.createElement("div", { className: 'bounce3', style: style })));
};
//# sourceMappingURL=spinner-loader.js.map